// extracted by mini-css-extract-plugin
export var container = "_ri-0";
export var dotAnimation = "_ri-2";
export var dotsLoading = "_ri-1";